// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"a360f0c8","644":"629c4691","732":"39b2bf6c"}[chunkId] + ".chunk.js";
};